export const ListStateConstant = {
    SAVE:  'LIST_STATE_SAVE',
    CLEAR: 'LIST_STATE_CLEAR',
};
